import { del, post, put } from '@utils/xhr';

class PermissionService {
  check(arraySection, arrayUser) {
    try {
      let canView = false;
      if (arraySection != null && arrayUser != null) {
        arraySection.forEach((section) => {
          arrayUser.forEach((user) => {
            if (section === user) canView = true;
          });
        });
      }

      return canView;
    } catch (err) {
      throw new Error(err);
    }
  }

  async create(permission) {
    try {
      const response = await post({
        url: `${process.env.apiPath}/api/permission`,
        data: {
          name: permission.name,
          guard_name: permission.guard_name,
        },
      });
      return response;
    } catch (error) {
      return error.response;
    }
  }

  async destroy(permission) {
    try {
      const response = await del({
        url: `${process.env.apiPath}/api/permission`,
        data: {
          id: permission.id,
        },
      });
      return response;
    } catch (error) {
      throw new Error(error.response);
    }
  }

  async update(permission, newPermission) {
    try {
      const response = await put({
        url: `${process.env.apiPath}/api/permission/${permission.id}`,
        data: {
          name: newPermission.name,
          guard_name: newPermission.guard_name,
        },
      });
      return response;
    } catch (error) {
      throw new Error(error.response);
    }
  }
}

export const permissionService = new PermissionService();
